__webpack_require__.p = "/maccabi/land/101093/";